import { MaskitoElementPredicate, MaskitoOptions } from '@maskito/core';

export const cpfMaskitoOptions: MaskitoOptions = {
  mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
};

export const cpfPredicate: MaskitoElementPredicate = async (el: any) =>
  (el as any).getInputElement();
